import React, { useState } from 'react';

import classNames from 'classnames/bind';
import { contextType } from 'react-modal';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function FontStyleComponent() {
  return (
    <div className={cx('text-format')}>
      <div>
        <div className={cx('headLine1BD')}>headLine1BD</div>
        <div className={cx('headLine1MD')}>headLine1MD</div>
        <div className={cx('headLine1RG')}>headLine1RG</div>
        <div className={cx('headLine2SB')}>headLine2SB</div>
        <div className={cx('headLine2MD')}>headLine2MD</div>
        <div className={cx('headLine3BD')}>headLine3BD</div>
        <div className={cx('headLine3MD')}>headLine3MD</div>
        <div className={cx('headLine3RG')}>headLine3RG</div>
        <div className={cx('title1BD')}>title1BD</div>
        <div className={cx('title1MD')}>title1MD</div>
        <div className={cx('title1RG')}>title1RG</div>
        <div className={cx('bodyBD')}>bodyBD</div>
        <div className={cx('bodyMD')}>bodyMD</div>
        <div className={cx('bodyRG')}>bodyRG</div>
        <div className={cx('bodyUL')}>bodyUL</div>
        <div className={cx('captionBD')}>captionBD</div>
        <div className={cx('captionMD')}>captionMD</div>
        <div className={cx('captionRG')}>captionRG</div>
        <div className={cx('captionUL')}>captionUL</div>
        <div className={cx('overlineBD')}>overlineBD</div>
        <div className={cx('overlineMD')}>overlineMD</div>
        <div className={cx('button1BD')}>button1BD</div>
        <div className={cx('button1MD')}>button1MD</div>
        <div className={cx('button2BD')}>button2BD</div>
        <div className={cx('button2MD')}>button2MD</div>
      </div>
      <details>
        <summary>textFormat.scss</summary>
        <code style={{ whiteSpace: 'pre-wrap' }}>{`.headline1BD {
    font-size: 24px;
    font-weight: 700;
    line-height: 140%;
}
.headline1MD {
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
}
.headline1RG {
    font-size: 24px;
    font-weight: 400;
    line-height: 140%;
}
.headline2SB {
    font-size: 22px;
    font-weight: 600;
    line-height: 140%;
}
.headline2MD {
    font-size: 22px;
    font-weight: 500;
    line-height: 140%;
}
.headline3BD {
    font-size: 20px;
    font-weight: 700;
    line-height: 140%;
}
.headline3MD {
    font-size: 20px;
    font-weight: 500;
    line-height: 140%;
}
.headline3RG {
    font-size: 20px;
    font-weight: 400;
    line-height: 140%;
}
.title1BD {
    font-size: 18px;
    font-weight: 700;
    line-height: 160%;
}
.title1MD {
    font-size: 18px;
    font-weight: 500;
    line-height: 160%;
}
.title1RG {
    font-size: 18px;
    font-weight: 400;
    line-height: 160%;
}
.title2BD {
    font-size: 16px;
    font-weight: 700;
    line-height: 160%;
}
.title2MD {
    font-size: 16px;
    font-weight: 500;
    line-height: 160%;
}
.title2RG {
    font-size: 16px;
    font-weight: 400;
    line-height: 160%;
}
.bodyBD {
    font-size: 14px;
    font-weight: 700;
    line-height: 160%;
}
.bodyMD {
    font-size: 14px;
    font-weight: 500;
    line-height: 160%;
}
.bodyRG {
    font-size: 14px;
    font-weight: 400;
    line-height: 160%;
}
.bodyUL {
    font-size: 14px;
    font-weight: 500;
    line-height: 160%;
    text-decoration: underline;
}
.captionBD {
    font-size: 12px;
    font-weight: 700;
    line-height: 160%;
}
.captionMD {
    font-size: 12px;
    font-weight: 500;
    line-height: 160%;
}
.captionRG {
    font-size: 12px;
    font-weight: 400;
    line-height: 160%;
}
.captionUL {
    font-size: 12px;
    font-weight: 500;
    line-height: 160%;
    text-decoration: underline;
}
.overlineBD {
    font-size: 10px;
    font-weight: 700;
    line-height: 160%;
}
.overlineMD {
    font-size: 10px;
    font-weight: 500;
    line-height: 160%;
}
.button1BD {
    font-size: 18px;
    font-weight: 700;
    line-height: 90%;
}
.button1MD {
    font-size: 18px;
    font-weight: 500;
    line-height: 90%;
}
.button2BD {
    font-size: 16px;
    font-weight: 700;
    line-height: 90%;
}
.button2MD {
    font-size: 16px;
    font-weight: 500;
    line-height: 90%;
}
  `}</code>
      </details>
    </div>
  );
}
export default FontStyleComponent;

export const path = '/font_style';
